import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const customerListSlice = createApi({
    reducerPath: "customerList",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        customerList: builder.query({
            query: (data) => ({ url: "/order-management/api/v1/customer/list", params: data, method: "GET" }),
        }),
    }),
});

export const { useCustomerListQuery } = customerListSlice;
